export const POPULAR_PRESET = {
  duration_days: 30,
  device_limit: 3,
  traffic_gb: 0,
};

